import { connect } from 'react-redux'
import ApplicationRowsComponent from '../../../components/employer/applications/applicationRows.component'
import {
  applicationsSaveAssignment,
  cancelOffer,
  completeOfferForm,
  filterApplicants,
  offerAssignment,
  rejectApplication,
  rejectWarning,
  updateViewApplication,
  updateReviewApplication,
  openWarningCloseCompleteOfferForm,
  closeWarningCloseCompleteOfferForm,
  copyPreviousAssignment,
  pinApplication,
  signSendContract,
  signAssignmentPad,
  closeSignContractScreen,
  closeApplicationSnackbar,
  previewAssignment
} from '../../../actions/employer'
import { convertDataToDict } from '../../../utils/employer/showIndustry.utils'

const mapStateToProps = (state) => {
  const areaOfWorkDict = convertDataToDict(state.assignments.areaOfWork)
  return {
    state,
    areaOfWorkDict: areaOfWorkDict,
    showRejectWarning: state.applications.showRejectWarning,
    offerToPerson: state.applications.offerToPerson,
    isOffer: state.applications.isOffer,
    isCompleteForm: state.applications.isCompleteForm,
    isEditAssignment: state.applications.isEditAssignment,
    openWarningCloseCompleteForm:
      state.assignments.openWarningCloseCompleteForm,
    showPdfDialog: state.applications.showPdfDialog,
    signPad: state.applications.signPad,
    selectedOfferedData: state.applications.selectedOfferedData,
    loadSignAndSend: state.loader.loadSignAndSend,
    showSnackbar: state.applications.showSnackbar,
    showFailedSnackbar: state.applications.showFailedSnackbar,
    isSigned: state.applications.isSigned,
    enableSendOrSignButton: state.applications.enableSendOrSignButton,
    showLeItemLoader: state.loader.showLeItemLoader,
    companyProfile: state.companyProfile.userData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    filterApplicants: (appJobID) => dispatch(filterApplicants(appJobID)),
    rejectWarning: () => dispatch(rejectWarning()),
    cancelOffer: () => dispatch(cancelOffer()),
    rejectApplication: (appID, uuid, email, appJobID, applicantData) =>
      dispatch(rejectApplication(appID, uuid, email, appJobID, applicantData)),
    updateViewApplication: (agreementId) =>
      dispatch(updateViewApplication(agreementId)),
    updateReviewApplication: (uuid, appID, appJobID) =>
      dispatch(updateReviewApplication(uuid, appID, appJobID)),
    offerAssignment: (selected) => dispatch(offerAssignment(selected)),
    completeOfferForm: (selected) => dispatch(completeOfferForm(selected)),
    applicationsSaveAssignment: (formValues) =>
      dispatch(applicationsSaveAssignment(formValues)),
    openWarningCloseCompleteOfferForm: () =>
      dispatch(openWarningCloseCompleteOfferForm()),
    closeWarningCloseCompleteOfferForm: () =>
      dispatch(closeWarningCloseCompleteOfferForm()),
    copyPreviousAssignment: () => dispatch(copyPreviousAssignment()),
    pinApplication: (application_id, agreement_id) =>
      dispatch(pinApplication(application_id, agreement_id)),
    signSendContract: (trim, isDraft, offeredData, directlySendContract) =>
      dispatch(
        signSendContract(trim, isDraft, offeredData, directlySendContract)
      ),
    signAssignmentPad: (selectedOfferedData) =>
      dispatch(signAssignmentPad(selectedOfferedData)),
    closeSignContractScreen: () => dispatch(closeSignContractScreen()),
    closeApplicationSnackbar: () => dispatch(closeApplicationSnackbar()),
    previewContract: (formData, isDirectOffer) =>
      dispatch(previewAssignment(formData, isDirectOffer))
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const ApplicationRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ApplicationRowsComponent)

export default ApplicationRowContainer
